import { t } from "@lingui/macro";
import "./Footer.css";
import twitterIcon from "img/ic_twitter.svg";
import discordIcon from "img/ic_discord.svg";
import emailIcon from "img/ic_email.svg";
import telegramIcon from "img/ic_telegram.svg";
import githubIcon from "img/ic_github.svg";
import mediumIcon from "img/ic_medium.svg";

type Link = {
  text: string;
  link: string;
  external?: boolean;
  isAppLink?: boolean;
};

type SocialLink = {
  link: string;
  name: string;
  icon: string;
};

export const FOOTER_LINKS: { home: Link[]; app: Link[] } = {
  home: [
    // { text: `Terms and Conditions`, link: "/terms-and-conditions" },
    // { text: `Referral Terms`, link: "/referral-terms" },
    // { text: `Media Kit`, link: "#", external: true },
    // { text: "Jobs", link: "/jobs", isAppLink: true },
  ],
  app: [
    // { text: `Media Kit`, link: "#", external: true },
    // { text: "Jobs", link: "/jobs" },
  ],
};

export const SOCIAL_LINKS: SocialLink[] = [
  { link: "https://twitter.com/mummyftm", name: "Twitter", icon: twitterIcon },
  { link: "https://medium.com/@mummyftm", name: "Medium", icon: mediumIcon },
  // { link: "https://github.com/gmx-io", name: "Github", icon: githubIcon },
  { link: "https://t.me/mummyftm", name: "Telegram", icon: telegramIcon },
  { link: "https://discord.gg/xqSJaw8sUB", name: "Discord", icon: discordIcon },
  // { link: "mailto:contact@mummy.finance", name: "contact", icon: emailIcon },
];
